'use client';

import btnFacebook from '@/assets/images/sns/btn-facebook.png';
import btnLine from '@/assets/images/sns/btn-line.png';
import btnLink from '@/assets/images/sns/btn-link.png';
import btnTwitter from '@/assets/images/sns/btn-twitter.png';
import { swal } from '@/lib/sweetalert';
import utilsStyles from '@/styles/modules/utils.module.scss';
import styles from './UrlShare.module.scss';

function UrlShare({
  url,
  twitterShareText,
}: {
  url: string;
  twitterShareText: string;
}) {
  const copyLink = async (e: React.MouseEvent) => {
    e.preventDefault();
    navigator.clipboard.writeText(url);
    await swal.messages({ messages: ['URLをコピーしました。'] });
  };

  return (
    <>
      <div className={styles.urlShare}>
        <p className={`${styles.shareLabel} ${utilsStyles.textBold}`}>シェアする</p>
        <ul className={styles.shareList}>
          <li>
            {/* Twitter */}
            <a
              href={`https://x.com/intent/tweet?text=${encodeURIComponent(
                twitterShareText,
              )}&url=${encodeURIComponent(url)}`}
              className={`${styles.shareLink} ${styles.shareLinkTwitter}`}
              rel='noreferrer nofollow'
              target='_blank'
            >
              <img src={btnTwitter.src} alt='Twitter' />
            </a>
          </li>
          <li>
            {/* Line */}
            <a
              href={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`}
              className={`${styles.shareLink} ${styles.shareLinkLine}`}
              rel='noreferrer nofollow'
              target='_blank'
            >
              <img src={btnLine.src} alt='line' />
            </a>
          </li>
          <li>
            {/* フェイスブック */}
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
              className={`${styles.shareLink} ${styles.shareLinkFacebook}`}
              rel='noreferrer nofollow'
              target='_blank'
            >
              <img src={btnFacebook.src} alt='Facebook' />
            </a>
          </li>
          <li>
            {/* コピー */}
            {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
            <a
              href='#'
              onClick={(e) => copyLink(e)}
              className={`${styles.shareLink} ${styles.shareLinkCopy}`}
              rel='noreferrer nofollow'
            >
              <img src={btnLink.src} alt='Copy' />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default UrlShare;
